<template lang="pug">
div.container
  // Loader
  div.loader(v-if="sending")
    progress(:value="uploadProgress" max="100")
    span {{ uploadProgress }}%
    p ファイル送信中です

  // Header
  header
    h1 商品情報の取り込み

  // File import area
  main
    div(class="message-area")
      | 取り込むデータファイルを選択してください

    div(class="select-area" @mouseenter="hover" @mouseleave="unhover")
      label(for="csv-select")
        font-awesome-icon.fa-5x(:style="iconStyle" icon="file-upload")
      input(type="file" accept=".csv,.xlsx,text/csv" id="csv-select" @change="select")

    div(class="button-area")
      span(v-if="file") {{ file.name }}
      span(v-else-if="error" class="error") CSVファイルを選択してください
      span(v-else) 未選択
      button(:disabled="!file" @click="submit") 送信
</template>

<script>
import axios from "axios";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "Admin",
  components: {
    FontAwesomeIcon: FontAwesomeIcon
  },
  data() {
    library.add(faFileUpload);
    return {
      error: false,
      iconStyle: { color: "gray" },
      file: null,
      sending: null,
      uploadProgress: 0
    };
  },
  mounted() {},
  methods: {
    select(e) {
      const file = e.target.files[0];
      const ext = ["csv", "xlsx"];
      if (file && ext.includes(file.name.split(".").pop())) {
        this.file = file;
        this.error = false;
      } else {
        this.file = null;
        this.error = true;
      }
    },
    hover() {
      this.iconStyle = { color: "black", transition: "all 0.3s" };
    },
    unhover() {
      this.iconStyle = { color: "gray", transition: "all 0.3s" };
    },
    submit() {
      this.sending = true;
      const params = {
        "mode": process.env.NODE_ENV,
        "name": this.file.name,
        "type": this.file.type
      };
      const apiURL =
        "https://3yf4x9dbpe.execute-api.ap-northeast-1.amazonaws.com/master/product";
      axios.put(apiURL, params).then(r => {
        if (r.status === 200) {
          const config = {
            onUploadProgress: e => {
              this.uploadProgress = Math.floor((e.loaded * 100) / e.total);
            }
          }
          axios.put(r.data.url, this.file, config).then(() => {
            this.sending = false;
            alert("ファイル送信が完了しました");
          });
        } else if (r.status === 204) {
          alert('前回投入したデータファイルが処理中です。時間をおいて再度お試しください。');
          this.sending = false;
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
body
  background: #f5f5f5

// container
.container
  align-items: center
  display: flex
  flex-direction: column
  padding-top: 100px

// Loader
.loader
  background: #ffffffbb
  height: 100%
  position: absolute
  text-align: center
  width: 100%
  z-index: 1

  progress
    margin-top: 20vh
    margin-right: 1em

  p
    font-size: 24px

// header
header h1
  font-size: 24px

//main
main
  background: white
  padding: 20px
  border: 1px solid lightgray
  border-bottom: 2px solid lightgray
  font-size: 16px

.select-area
  display: flex
  justify-content: center
  margin: 25px 0
  width: 100%

  label
    align-items: center
    background: #f8f8f8
    border: 2px dashed #cccccc
    border-radius: 8px
    display: flex
    height: 48px
    justify-content: center
    padding: 48px 124px
    width: 96px

  input
    display: none

.button-area
  display: flex
  justify-content: space-between;

  span
    font-size: 8px
    max-width: 170px

  button
    background: #1caf9a
    border: none
    border-radius: 0
    color: white
    font-size: 16px
    height: auto
    padding: 4px 15px
    width: 50%

    &:disabled
      opacity: 0.4

// etc
.error
  color: red
</style>
